import { Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import React from 'react';
import { UserRegisterT } from './RegisterScreen';
import Validator from 'jsonschema'
import TextFieldValidate from '../../components/TextFieldValidate';
import CheckBoxList from '../../components/CheckBoxList';
import CheckBoxListUI from '../../components/CheckBoxListUI';


const EquipmentItems = {
    "dolly": "Dolly",
    "floor_dolly": "Floor Dolly",
    "ratchet_straps": "Ratchet Straps",
    "moving_pads": "Moving Pads (at least 5)",
}
var schema = {
    "id": "/formWorkerRegister",
    "type": "object",
    "properties": {
        "companyCode": { "type": "string", "minLength": 1 },
        // "equipment": { "type": "string", "minLength": 2 },
    },
    "required": ["companyCode"]
};


export type IWorkerTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    nextTab(fields: UserRegisterT): void
}

const WorkerTab: React.FC<IWorkerTabProps> = (props) => {
    const validatorRef = React.useRef(new Validator.Validator())
    const [equipmentOptions, setEquipmentOptions] = React.useState([]);

    React.useEffect(() => {
        preparListCheckBox()
    }, []);


    const preparListCheckBox = () => {
        let items = []
        Object.keys(EquipmentItems).map((key, index) => {
            items.push({
                value: key,
                label: EquipmentItems[key],
                checked: false,
                disabled: false,
            })
        })
        setEquipmentOptions(items)
    }
    const checkValidate = React.useCallback((params: UserRegisterT) => {
        if (!validatorRef || !validatorRef.current) {
            return false
        }
        const valid = validatorRef.current.validate(params, schema)
        if (!valid.valid) {
            return false
        }
        return true
    }, [props.fields]);


    const next = async (params: any): Promise<string> => {
        try {

            if (checkValidate(params)) {
                props.nextTab(params)
                return ""
            }
        } catch (error) {
            throw error
        }
    }


    const onChangeField = (key: string, value: any): void => {
        props.onChangeField(key, value)

    }
    // equipment
    const getValue = (key, fields) => {
        return fields[key] && fields[key] != null ? fields[key] : ""
    }

    /**
   * 
   * @param value 
   * @param checked 
   */
    const onCheckBoxPress = (value: string, checked: boolean) => {

    }

    return (
        <Grid container spacing={4}>


            <Grid item xs={12} >
                <TextFieldValidate
                    name="companyCode"
                    fullWidth 
                    // required 
                    variant="standard"
                    label="Company Code"
                    value={`${getValue("companyCode", props.fields)}`}
                    onChange={(event: any) => {
                        let value = event.target.value
                        onChangeField("companyCode", value)
                    }}
                    onValidateError={(value) => {
                        return value == "" ? "Required" : ""
                    }}
                />
            </Grid>
            <Grid item xs={12}>

                <FormControlLabel
                    label="Do you have reliable transportation?"
                    // color="success"
                    checked={getValue("reliableTransportation", props.fields) == true ? true : false}
                    onChange={() => {
                        onChangeField('reliableTransportation', !props.fields.agree)
                    }}
                    control={<Checkbox />}
                />

            </Grid>
            <Grid item xs={12}>
                <FormControl component="fieldset">
                    <FormLabel id="equipment-label">Check the equipment you own and can use on the job:</FormLabel>
                    <CheckBoxListUI
                        data={equipmentOptions}
                        onCheckBoxPress={onCheckBoxPress}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} >
                <Button
                    fullWidth
                    disabled={!checkValidate(props.fields)}
                    color="success"
                    variant="contained"
                    onClick={(e) => {
                        next(props.fields)
                    }}>
                    <Typography variant="button" color="#fff">Next</Typography>
                </Button>
            </Grid>
        </Grid>
    );
}

export default WorkerTab